// this file is automatically generated by git.revision.js script
export const versions = { revision: '22bb6980b9' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '22bb6980b9';
